//export const API_URL = "";
export const API_URL = "https://app.enjoyablewarmth.com";
//export const API_URL = "https://localhost:5001";



// WEBPACK FOOTER //
// ./src/modules/constants.js